// extracted by mini-css-extract-plugin
export default {"botao":"botao_botao__Ci0dh","primary":"botao_primary__dzLQo","secondary":"botao_secondary__znXXK"};